import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
//import { useNavigate } from 'react-router-dom';
import Loading from "../components/layouts/loading";

export default function User() {

  const [done, setDone] = useState(undefined);

  useEffect(() => {
    //setTimeout(() => {
      setDone(true);
    //}, 1000);
  }, []);

  return (
    <>
      <div className='User-form'>
        {!done ? <Loading /> : <UserScreen />}
      </div>
    </>
  )

  function UserScreen() {

    return (
      <main style={{ padding: "1rem 0" }}>

        <br /><br />
        <h2>Pagina User {localStorage.getItem("username")}</h2>
        <Link to="/administrator">Vai a Admin</Link>

      </main>
    )

  }
}